import React from "react";

function Error (props) {
    return (
        <div>
            Sorry, Page doesn't Exist... It is probably still under construction.
        </div>
    )
}

export default Error;